import React, { Component } from 'react';
import utilFunction from '../../../containers/function'
import BarChart from '../graphs/crossfilterGraphs/barChart';

const RotationHistogramGraph = (props) => (
  <div id="rotation-histogram-graph" className="dc-chart-parent">
    <BarChart 
      id={"rotation-histogram-graph-component"} 
      additionalCrossfilterData={null}
      crossfilerData={utilFunction.generateCrossfilter(props.data)}
      stack={false} 
      dimension={{
        formatFunction:[],
        name:"time",
        originalName:"time",
        reduceFunction:{"type":"CONTINUOUS_GROUP","typeof":"NUMBER"}
      }}
      metrics={[{
        config:{},
        filter: [],
        formatFunction: [],
        metric: "count",
        name: "count",
        reduceFunction: {type: "AVG"},
        type: "AVG"
      }]} 
      config={{
        "tooltip":{"valuesConfig":[
          {"identifier":"x","valueFormat":{"type":"STRING","format":""},"wrapper":`<div><span style='font-weight: bold;'>%v hrs</span> ${props.language.fatigue_indicators.labels.betweenStartShifts}:</div>`},
          {"identifier":"y","valueFormat":{"type":"NUMBER","format":"d"},"wrapper":`<div><span style='font-weight:bold;'>%v</span> ${props.language.fatigue_indicators.labels.times}</div>`}
        ]},
        "colors":["#0067B0"],"gap":120,
        "xAxis":{"label":props.language.fatigue_indicators.labels.hoursBetweenStartShifts,"interval":2,"autoRange":{"active":false,"min":0,"max":48,fixWidth:true}},
        "yAxis":{"show":false}
      }}
      dashboardId={"detail_histograms"}
    />
  </div>
);
  
export default RotationHistogramGraph;


// WEBPACK FOOTER //
// ./source/client/components/common/fatigue/rotationHistogramGraph.jsx